<template>
  <div class="container">
    <div class="searchArea">
      <div class="search-side">
        <img src="@/assets/img/CA_Club_black.png" class="entity_logo floatright align-entity" />
      </div>
      <div class="search-combo">
        <input type="text" class="search-box" v-model.lazy="searchString" v-debounce="1000" :placeholder="$t('clubs.search')" autofocus>
        <font-awesome-icon icon="search" class="icon-overlap"/>
      </div>
      <div class="search-side">
        <div v-if="isLoading" class="spincontainer">
          <font-awesome-icon icon="cog" class="fa-spinner fa-spin icon" /> loading...
        </div> 
      </div>
    </div>
  
    <clubs-list :clubs="clubs" :listType="'Card'"></clubs-list>
  
 </div>
</template>

<script>
import {user} from "@/components/users";
import ClubsList from "@/components/clubs/ClubsList";
import {RestAPI} from "@aws-amplify/api-rest";

const apiName = 'api';
const listPath = '/Club';
const myInit = { 
  response: false,
};


export default {
  name: 'ClubsDashboard',
  components: {ClubsList},
  data: function () {
    return {
      searchString: "",
      clubs: [],
      lastKey: "",
      loading: false,
    }
  },
  computed: {
    isLoading() {
      return this.loading;
    },
    loggedIn() {
      return user.loggedIn
    }
  },
  watch: {
    searchString: function () {
      this.loadClubs();
    }
  },
  methods: {
    loadClubs: function() {
    let that = this
    if (this.searchString == "") {
        this.clubs = [];
        this.loading = false;
    } else {
      this.loading = true;
      let fullPath = listPath + "?name=" + encodeURIComponent(this.searchString);
      console.log("loading clubs: " + fullPath);
      RestAPI
          .get(apiName, fullPath, myInit)
          .then(response => {
            that.clubs = response
            console.log("clubs loaded: " + that.clubs.length);
          })
          .catch(error => {
            console.log(error.response);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  },
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.spincontainer {
  margin-left: 10px;
  padding-top: 12px;
}

@keyframes spinner {
  to { transform: rotate(360deg); }
}
.fa-spinner {
  animation: spinner 3s linear infinite;
}


/* mobile */
@media screen and (max-width: 600px) {
  .container {
    padding: 1vw;
    width: 98vw;
  }

  header {
    padding: 1vw;
  }

  input {
    width: 95vw;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .container {
    padding: 1vw;
    width: 70vw;
  }

  input {
    width: 30vw;
  }

  header {
    padding: 1vw;
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  .container {
    padding: 1vw;
    width: 50vw;
  }

  input {
    width: 30vw;
  }

  header {
    padding: 1vw;
  }
}


</style>
